import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { AufgabeSharedModule } from '@schir-int-client/aufgabe-shared';
import { TechModule } from '@schir-int-client/tech';
import { AufgabenInVerfuegungContainerComponent } from './aufgaben-in-verfuegung-container/aufgaben-in-verfuegung-container.component';
import { AufgabeAbschriftBodyComponent } from './aufgaben-in-verfuegung/aufgabe-in-verfuegung/aufgabe-abschrift-body/aufgabe-abschrift-body.component';
import { AufgabeInVerfuegungComponent } from './aufgaben-in-verfuegung/aufgabe-in-verfuegung/aufgabe-in-verfuegung.component';
import { AufgabeMitteilungBodyComponent } from './aufgaben-in-verfuegung/aufgabe-in-verfuegung/aufgabe-mitteilung-body/aufgabe-mitteilung-body.component';
import { AufgabeRechnungsstellungBodyComponent } from './aufgaben-in-verfuegung/aufgabe-in-verfuegung/aufgabe-rechnungsstellung-body/aufgabe-rechnungsstellung-body.component';
import { AufgabeVersandBodyComponent } from './aufgaben-in-verfuegung/aufgabe-in-verfuegung/aufgabe-versand-body/aufgabe-versand-body.component';
import { AufgabeWiedervorlageBodyComponent } from './aufgaben-in-verfuegung/aufgabe-in-verfuegung/aufgabe-wiedervorlage-body/aufgabe-wiedervorlage-body.component';
import { AufgabeZertifikatBodyComponent } from './aufgaben-in-verfuegung/aufgabe-in-verfuegung/aufgabe-zertifikat-body/aufgabe-zertifikat-body.component';
import { KorrespondenzButtonComponent } from './aufgaben-in-verfuegung/aufgabe-in-verfuegung/korrespondenz-button/korrespondenz-button.component';
import { KorrespondenzVorlageButtonsComponent } from './aufgaben-in-verfuegung/aufgabe-in-verfuegung/korrespondenz-vorlage-buttons/korrespondenz-vorlage-buttons.component';
import { AufgabenInVerfuegungComponent } from './aufgaben-in-verfuegung/aufgaben-in-verfuegung.component';
import { AufgabeAbschriftEditorComponent } from './aufgaben/aufgabe-abschrift-editor/aufgabe-abschrift-editor.component';
import { AufgabeMitteilungEditorComponent } from './aufgaben/aufgabe-mitteilung-editor/aufgabe-mitteilung-editor.component';
import { AufgabeRechnungsstellungEditorComponent } from './aufgaben/aufgabe-rechnungsstellung-editor/aufgabe-rechnungsstellung-editor.component';
import { AufgabeVersandEditorComponent } from './aufgaben/aufgabe-versand-editor/aufgabe-versand-editor.component';
import { AufgabeWiedervorlageEditorComponent } from './aufgaben/aufgabe-wiedervorlage-editor/aufgabe-wiedervorlage-editor.component';
import { AufgabeWithStaticTaetigkeitEditorComponent } from './aufgaben/aufgabe-with-static-taetigkeit-editor/aufgabe-with-static-taetigkeit-editor.component';
import { AufgabeZertifikatEditorComponent } from './aufgaben/aufgabe-zertifikat-editor/aufgabe-zertifikat-editor.component';
import { NotizInAufgabeEditorComponent } from './aufgaben/notiz-in-aufgabe-editor/notiz-in-aufgabe-editor.component';
import { CreateAufgabeDialogComponent } from './create-aufgabe-dialog/create-aufgabe-dialog.component';
import { CreateKorrespondenzDialogComponent } from './create-korrespondenz-dialog/create-korrespondenz-dialog.component';
import { KontaktKategorieCheckboxesComponent } from './kontakt-kategorie-checkboxes/kontakt-kategorie-checkboxes.component';
import { AufgabeAnschreibenEditorComponent } from './aufgaben/aufgabe-anschreiben-editor/aufgabe-anschreiben-editor.component';
import { AufgabeSchuldtitelEditorComponent } from './aufgaben/lfpr/aufgabe-schuldtitel-editor/aufgabe-schuldtitel-editor.component';
import { AufgabeLfprKostenEditorComponent } from './aufgaben/lfpr/aufgabe-kosten-editor/aufgabe-lfpr-kosten-editor.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AufgabeLfprMitteilungEditorComponent } from './aufgaben/lfpr/aufgabe-mitteilung-editor/aufgabe-lfpr-mitteilung-editor.component';
import { AufgabeLfprWeglegenEditorComponent } from './aufgaben/lfpr/aufgabe-weglegen-editor/aufgabe-lfpr-weglegen-editor.component';
import { AufgabeLfprBlattabschriftEditorComponent } from './aufgaben/lfpr/aufgabe-blattabschrift-editor/aufgabe-lfpr-blattabschrift-editor.component';
import { AufgabeMessbriefEditorComponent } from './aufgaben/aufgabe-messbrief-editor/aufgabe-messbrief-editor.component';
import { AufgabeZertifikatsauszugEditorComponent } from './aufgaben/aufgabe-zertifikatsauszug-editor/aufgabe-zertifikatsauszug-editor.component';
import { AufgabeZertifikatsauszugBodyComponent } from './aufgaben-in-verfuegung/aufgabe-in-verfuegung/aufgabe-zertifikatsauszug-body/aufgabe-zertifikatsauszug-body.component';
import { ChangeFileSuccessDialogComponent } from './aufgaben-in-verfuegung/aufgabe-in-verfuegung/change-file-success-dialog/change-file-success-dialog.component';
import { AufgabeHeimatverlegungEditorComponent } from './aufgaben/aufgabe-heimatverlegung-editor/aufgabe-heimatverlegung-editor.component';
import { AufgabeHeimatverlegungBodyComponent } from './aufgaben-in-verfuegung/aufgabe-in-verfuegung/aufgabe-heimatverlegung-body/aufgabe-heimatverlegung-body.component';
import { AufgabeWithNotizEditorComponent } from './aufgaben/aufgabe-with-notiz-editor/aufgabe-with-notiz-editor.component';

@NgModule({
	imports: [
		CommonModule,
		TechModule,
		MatFormFieldModule,
		MatSelectModule,
		MatButtonModule,
		MatDialogModule,
		MatProgressSpinnerModule,
		MatDatepickerModule,
		MatCheckboxModule,
		MatButtonToggleModule,
		MatInputModule,
		MatRadioModule,
		FormsModule,
		AufgabeSharedModule,
		ReactiveFormsModule,
		RouterModule,
		MatTooltipModule,
		AufgabeHeimatverlegungEditorComponent,
		AufgabeHeimatverlegungBodyComponent,
		AufgabeWithNotizEditorComponent,
		NotizInAufgabeEditorComponent,
	],
	declarations: [
		AufgabenInVerfuegungComponent,
		AufgabeInVerfuegungComponent,
		CreateAufgabeDialogComponent,
		CreateKorrespondenzDialogComponent,
		AufgabenInVerfuegungContainerComponent,
		KorrespondenzButtonComponent,
		AufgabeZertifikatBodyComponent,
		KontaktKategorieCheckboxesComponent,
		KorrespondenzVorlageButtonsComponent,
		AufgabeWithStaticTaetigkeitEditorComponent,
		AufgabeVersandEditorComponent,
		AufgabeAnschreibenEditorComponent,
		AufgabeZertifikatEditorComponent,
		AufgabeVersandBodyComponent,
		AufgabeAbschriftEditorComponent,
		AufgabeAbschriftBodyComponent,
		AufgabeMitteilungEditorComponent,
		AufgabeMitteilungBodyComponent,
		AufgabeMessbriefEditorComponent,
		AufgabeWiedervorlageBodyComponent,
		AufgabeWiedervorlageEditorComponent,
		AufgabeRechnungsstellungEditorComponent,
		AufgabeRechnungsstellungBodyComponent,
		AufgabeLfprKostenEditorComponent,
		AufgabeSchuldtitelEditorComponent,
		AufgabeLfprMitteilungEditorComponent,
		AufgabeLfprBlattabschriftEditorComponent,
		AufgabeLfprWeglegenEditorComponent,
		AufgabeZertifikatsauszugEditorComponent,
		AufgabeZertifikatsauszugBodyComponent,
		ChangeFileSuccessDialogComponent,
	],
	exports: [
		AufgabenInVerfuegungComponent,
		AufgabeInVerfuegungComponent,
		CreateAufgabeDialogComponent,
		AufgabeWiedervorlageEditorComponent,
		AufgabeRechnungsstellungEditorComponent,
		AufgabeWithStaticTaetigkeitEditorComponent,
		AufgabeVersandEditorComponent,
		AufgabeAnschreibenEditorComponent,
		AufgabeAbschriftEditorComponent,
		AufgabeMitteilungEditorComponent,
		AufgabeMessbriefEditorComponent,
		AufgabeZertifikatEditorComponent,
		AufgabeWiedervorlageEditorComponent,
		AufgabeLfprKostenEditorComponent,
		AufgabeSchuldtitelEditorComponent,
		AufgabeLfprMitteilungEditorComponent,
		AufgabeLfprBlattabschriftEditorComponent,
		AufgabeLfprWeglegenEditorComponent,
		AufgabeZertifikatsauszugEditorComponent,
	],
})
export class AufgabeModule {}
